export default "__VITE_ASSET__CNBRhwZt__"